"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[5428],{

/***/ 3832:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class CoffeeListController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = ["scrollTrack"]

  nextPage() {
    this.scrollTrackTarget.scrollBy({ left: this.#pageSize(), behavior: "smooth" })
  }

  previousPage() {
    this.scrollTrackTarget.scrollBy({ left: -this.#pageSize(), behavior: "smooth" })
  }

  #pageSize() {
    return this.scrollTrackTarget.children[0].children[0].clientWidth
  }
}

Stimulus.register("coffee-list", CoffeeListController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(3832)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);